import { SpinRequestBuilder } from "ags/integration/builders/requests/spin-request-builder";
import { Gameplay } from "appworks/model/gameplay/gameplay";
import { RequestBuilder } from "appworks/server/builders/request-builder";
import { SocketRequest } from "appworks/server/connectors/socket-connector";
import { gameiomModel } from "gameiom/model/gameiom-model";
import { FreespinRequestPayload } from "slotworks/model/gameplay/requests/freespin-request-payload";

export class FreespinRequestBuilder implements RequestBuilder {
    public filter(request: any): boolean {
        return request instanceof FreespinRequestPayload;
    }

    public build(gameplay: Gameplay, request: any): SocketRequest {
        let force: string | number[] = SpinRequestBuilder.force;

        SpinRequestBuilder.force = null;

        const body = {
            publicState: {
                action: "freespin",
                gameId: gameiomModel.gameId,
                force
            }
        };

        if (body.publicState.force === null) {
            delete body.publicState.force;
        }

        return new SocketRequest(body, gameiomModel.url);
    }
}
